export const ListCreate = ({handleCreateList, listTitle, setListTitle, setShowCreateList}) => {
    return (
        <form
            className="boardPage__createList"
            onSubmit={handleCreateList}
        >
            <input
                type="text"
                placeholder="Enter list title..."
                value={listTitle}
                onChange={(e) => setListTitle(e.target.value)}
                autoFocus
            />

            <div className="boardPage__createActions">
                <button type="submit">Add list</button>
                <button
                    type="button"
                    onClick={() => {
                        setShowCreateList(false);
                        setListTitle("");
                    }}
                >
                    Cancel
                </button>
            </div>
        </form>
    )
}